export default class DisplayDataUtil {
  static validationRules = {
    required: value => !!value || '必須の項目です',
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'メールアドレスの形式が正しくありません'
    },
    password: value => {
      const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[!-~]{8,100}$/
      return pattern.test(value) || '8文字以上で半角英大小文字を含めてください'
    }
  }

  static convertTimestampToDateFormat (timestamp) {
    var d = new Date(timestamp)
    var year = d.getFullYear()
    var month = d.getMonth() + 1
    var day = d.getDate()
    var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
    var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
    var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
    return year + '/' + month + '/' + day + ' ' + hour + ':' + min + ':' + sec
  }
}
